import React, {useEffect} from 'react';
import CustomBreadcrumbs from 'utility/CustomBreadcrumbs';
import {filter, get} from 'lodash';
import {HelmetWrapper, basicHelmetGenerator} from 'utility/DefaultMeta';
import { Row, Col } from '@zendeskgarden/react-grid';
import { XXL, LG, MD} from '@zendeskgarden/react-typography';
import ServicesHero from './components/ServicesHero/ServicesHero';
import ServicesOffered from "./components/ServicesOffered/ServicesOffered";
import ChooseOurCompany from 'components/ChooseOurCompany/ChooseOurCompany';
import PageViewWrapper, {trackCurrentPage} from 'higherOrder/PageViewWrapper';
import {Button} from 'theme/Button';
import { variables } from 'theme/variables';
import {
  LandingSection,
  LandingPage,
  InlineSection
} from './Services.styles';

import {trackClick} from 'utility/analytics';
import {openModal} from 'state/modals/actions';
import servicesList from './servicesList.json';


const {
  custom_light_grey,
} = variables;



const Services = (props) => {
  function goTorequest() {
    trackClick('inquire', 'Submit RFQ', 'Services');
    openModal({
      type: 'inquireFormModal',
      data: {
        selectService: true
      }
    })
  }

  const activeService = filter(servicesList, (d) => !props.match.params[0] ? true : d.link === props.match.params[0])
  const isFiltered = servicesList.length > activeService.length;

  const selectedService = (isFiltered && activeService && activeService[0]);

  useEffect(() => {
    if (props.match.params[0]) {
      trackCurrentPage(props.match.params[0])
    }
  }, [props.match.params[0]]);

  return (
    <LandingPage>
      
      <HelmetWrapper metadata={basicHelmetGenerator({
        title: get(selectedService, 'metaTitle') || 'MRI Technologies - Our Services: MRI and RF Shielding, MRI Procurement, MRI Intallation',
        description: get(selectedService, 'metaDescription') ||'Our Services Include MRI and RF Shielding, MRI Procurement, MRI Intallation, CT Procurment, Maintenance Programs, Testing and Repairs',
      })} />

      <LandingSection colStyle={{position: 'unset'}} style={{paddingBottom: 0, paddingTop: '20px'}}>
        {
          isFiltered ?
          <div style={{marginBottom: '20px'}}>
            <CustomBreadcrumbs disableDefaults={false} removeRoot={true} omit={['/c']} />
          </div> : null
        }
        <ServicesHero activeService={selectedService}/>
      </LandingSection>

      

      <LandingSection style={{paddingBottom: 0, paddingTop: isFiltered ? '40px' : '40px'}}>
        <ServicesOffered {...props} isFiltered={isFiltered} services={servicesList} activeService={activeService} />
      </LandingSection>

    
      <LandingSection style={{marginBottom: '80px'}}>
        <ChooseOurCompany />
      </LandingSection>


      <InlineSection style={{marginBottom: 0, marginTop: '60px'}}>
          <LandingSection background={custom_light_grey}>
            <div style={{maxWidth: '999px', margin: '0 auto', padding: '40px 0'}}>
              <Row alignCenter>
                <Col size={12} justifyCenter column>
                  <MD center blue uppercase paddingBottomLg semibold>Submit a Request</MD>
                  <XXL center bold>Work With Us On Your Next Project</XXL>
                  <LG style={{maxWidth: '750px', margin: '0 auto'}} center scaled slate paddingTopLg paddingBottomLg light>
                    Leading the Industry in Buying & Selling Medical Eqipment, RF Shield Quality, Assurance Testing, and Maintenance Programs.
                  </LG>
                  <Row style={{margin: '0 auto', marginTop: '30px'}}>
                    <Col size={12} sm="auto">
                      <Button onClick={goTorequest} pairButton size="large" spacingBottom primary>Submit A Request</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          </LandingSection>
        </InlineSection>

        
    </LandingPage>
  )
}


export default PageViewWrapper(Services, {pageName: 'Services'})
